import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  MdOutlineDashboard,
  MdOutlineGroup,
  HiOutlineUserGroup,
  FiShield,
  FiServer,
  FiActivity,
} from '@/config/icons';
import { useTranslation } from '@/hooks/useTranslation';
import styles from './Sidebar.module.css';

interface SidebarProps {
  isOpen: boolean;
}

/**
 * Sidebar Component
 * Vertical navigation menu
 */
const Sidebar: FC<SidebarProps> = ({ isOpen }) => {
  const { t } = useTranslation();
  
  const menuItems = [
    { path: '/', label: t('navigation.dashboard'), icon: MdOutlineDashboard },
    { path: '/users', label: t('navigation.users'), icon: MdOutlineGroup },
    { path: '/groups', label: t('navigation.groups'), icon: HiOutlineUserGroup },
    { path: '/agents', label: t('navigation.agents'), icon: FiServer },
    { path: '/certificates', label: t('navigation.certificates'), icon: FiShield },
    { path: '/events', label: t('navigation.events'), icon: FiActivity },
    // { path: '/event-logs', label: t('navigation.eventLogs'), icon: FiFileText },
  ];

  return (
    <aside className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}>
      <nav className={styles.nav}>
        <ul className={styles.menuList}>
          {menuItems.map((item) => (
            <li key={item.path} className={styles.menuItem}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `${styles.menuLink} ${isActive ? styles.active : ''}`
                }
              >
                <span className={styles.icon}>
                  <item.icon className="w-5 h-5" />
                </span>
                <span className={styles.label}>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;